import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(_jsx("path", {
  d: "m12.961 12 6.09-6.09a.678.678 0 1 0-.961-.961L12 11.039l-6.09-6.09a.678.678 0 1 0-.961.961l6.09 6.09-6.09 6.09a.678.678 0 0 0 .481 1.16.676.676 0 0 0 .481-.199l6.09-6.09 6.09 6.09c.133.133.306.199.481.199s.348-.066.481-.199a.678.678 0 0 0 0-.961L12.963 12z"
}), 'Clear');